<script setup>
    import { defineProps, ref, onMounted, computed } from "vue";
    import Record from "@/components/three-in-one/toshiba/shopify-component/add-to-cart/Index.vue"
    import { _CSP_ORDER_STATUS, _CSR_IS_B2b } from '@/const/shopifyConst.js';
    import { handleCopy, getJumpLink } from "@/utils/common.js"
    import Price from '@/components/three-in-one/toshiba/price/v1/ShopifyPrice.vue';
    import OrderStatus from '@/components/three-in-one/toshiba/shopify-component/account/components/OrderStatus.vue';
    import { useGetStorage } from '@/hooks/common/useStorage';
    import useHomeProperties from "@/hooks/common/useHomeProperties";
    import { isPhonePortrait } from "@/hooks/common/useUtils";
    const props = defineProps({
        config: {
            type: Object,
            default: null
        },
        customer: {
            type: Object,
            default: null
        },
        orderDetailAry: {
            type: Array,
            default: () => []
        }
    });
    // eslint-disable-next-line
   const { enableBazaarvoice='N', archiveLabel } = useHomeProperties();
    // const isB2b = localStorage.getItem(_CSR_IS_B2b) === 'true';
    const isB2b = useGetStorage(_CSR_IS_B2b) === true;
    const emit = defineEmits(['change']);
    const handleBack = () => {
        emit("handleOrderDetailsBack")
    }
    const orderDetailsConfig = ref({})
    const orderListConfig = ref({})
    const showInvoice = ref(false)
    const recordRenderingFailed = ref(false);
    // eslint-disable-next-line
    const orderDetailCommonInfo = ref({ ...props.orderDetailAry[0] })

    const totalQuantity = computed(() => {
        return props.orderDetailAry.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.quantity;
        }, 0)
    })
    
    // 显示Record的条件
    const showRecord = computed(() => {
        return (item) => {
            return item.sku && [_CSP_ORDER_STATUS._DELIVERED , _CSP_ORDER_STATUS._CANCELLED].includes(item.orderStatus);
        }
    })

    // 显示Bazaarvoice的条件
    const showBazaarvoice = computed(() => {
        return (item) => {
            return enableBazaarvoice === 'Y' && item.sku && (item.orderStatus === _CSP_ORDER_STATUS._DELIVERED);
        }
    })
    onMounted(() => {
        window.scrollTo(0, 0);
        const { orderDetail: detailsConfig={}, orderList: listconfig={}, cancelButton, backButton, conpySuccessHint, orderStatusLabel = {} } = props.config || {}
        orderListConfig.value = { ...listconfig, cancelButton, backButton, conpySuccessHint, orderStatusLabel }
        orderDetailsConfig.value = detailsConfig
        const invoiceStatusAry = orderDetailsConfig.value?.invoiceStatus?.split(',') || ""
        showInvoice.value = orderDetailsConfig.value?.invoiceTitle && 
        (!orderDetailsConfig.value?.invoiceStatus 
        ||  !orderDetailsConfig.value?.invoiceCondition || ( invoiceStatusAry && orderDetailsConfig.value?.invoiceCondition === 'status' && invoiceStatusAry.includes(orderDetailCommonInfo.value?.orderStatus)))

    })
    // 点击标题跳转
    const handleJump = (item) => {
        const { titleLink, archiveHyperLink, link } = item;
        if (archiveHyperLink) {
            return location.href = getJumpLink(item.archiveHyperLink);
        }
        if(link) {
            return location.href = getJumpLink(item.link);
        }
        if (titleLink) {
            location.href = getJumpLink(item.titleLink);
        }
    }
    const handleRecordRenderingFailed = () => {
        recordRenderingFailed.value = true;
    } 
</script>

<template>
    <div class="csr-account-order-details csr-order-details">
        <div class="csr-order-details__crumbs__wrapper">
            <div class="csr-order-details__crumbs">
                <div @click="handleBack" class="csr-order-details__crumbs-back">
                    <div class="csr-account__back__icon"></div>
                    <div class="csr-order-details__crumbs-back-txt">{{ isPhonePortrait() ? orderDetailsConfig.title : orderListConfig.backButton }}</div>
                </div>
                <!-- <div class="csr-order-details__crumbs-title">{{ orderDetailsConfig.title }}</div> -->
            </div>
        </div>
        <div class="csr-order-details__order-info-header" v-if="orderDetailsConfig.orderInfoLabel">
            <div class="csr-order-details__order-title">
                {{ orderDetailsConfig.orderInfoLabel }}
            </div>
            <div class="csr-order-details__btns">
                <a v-if="orderDetailCommonInfo.successfulFulfillmentsUrl && orderDetailCommonInfo.orderStatus == _CSP_ORDER_STATUS._FULFILLED"
                    :href="orderDetailCommonInfo.successfulFulfillmentsUrl"
                    class="csr-order-details__btn">{{
                    orderListConfig.trackButton }}</a>
                <!-- <button class="csr-order-details__btn">Track</button> -->
                <!-- <button class="csr-order-details__btn">Review</button> -->
            </div>
        </div>
        <div class="csr-order-details__content-box">
            <div class="csr-order-details__order-info">
                <ul class="csr-order-details__order-info-content">
                    <li class="csr-order-details__order-info-item">
                        <div class="csr-order-details__order-info-item-label">
                            {{ orderDetailsConfig.orderStatusLabel }}
                        </div>
                        <div class="csr-order-details__order-info-item-value">
                                <OrderStatus
                                    v-if="orderDetailCommonInfo?.orderStatus"
                                    :order-status="orderDetailCommonInfo?.orderStatus"
                                    :label="orderListConfig.orderStatusLabel?.[orderDetailCommonInfo?.orderStatus]">
                                </OrderStatus>
                            <!-- <OrderStatus :order-status="'delivered'" :label="'delivered'"></OrderStatus> -->
                        </div>
                    </li>
                    <li v-if="orderDetailCommonInfo.logisticsCode" class="csr-order-details__order-info-item">
                        <div class="csr-order-details__order-info-item-label">
                            {{ orderDetailsConfig.logisticsCodeLabel }}
                        </div>
                        <div class="csr-order-details__order-info-item-value">
                            <span>{{ orderDetailCommonInfo.logisticsCode }}</span>
                            <img @click="handleCopy(orderDetailCommonInfo.logisticsCode,orderListConfig.conpySuccessHint)"
                                class="csr-order-details__copy-image lazyload"
                                src="@/assets/images/toshiba/copy.png" />
                        </div>
                    </li>
                    <li class="csr-order-details__order-info-item">
                        <div class="csr-order-details__order-info-item-label">
                            {{ orderDetailsConfig.orderDateLabel }}
                        </div>
                        <div class="csr-order-details__order-info-item-value">
                            <span>{{ orderDetailCommonInfo.processedAt }}</span>
                        </div>
                    </li>
                    <li class="csr-order-details__order-info-item">
                        <div class="csr-order-details__order-info-item-label">
                            {{ orderDetailsConfig.orderNumberLabel }}
                        </div>
                        <div class="csr-order-details__order-info-item-value">
                            <span>{{ orderDetailCommonInfo.orderNumber }}</span>
                        </div>
                    </li>
                    <li class="csr-order-details__order-info-item">
                        <div class="csr-order-details__order-info-item-label">
                            {{ orderDetailsConfig.addresseeLabel }}
                        </div>
                        <div class="csr-order-details__order-info-item-value">
                            <span>{{ orderDetailCommonInfo.addressee }}</span>
                        </div>
                    </li>
                    <li class="csr-order-details__order-info-item">
                        <div class="csr-order-details__order-info-item-label">
                            {{ orderDetailsConfig.shippingAddressLabel }}
                        </div>
                        <div class="csr-order-details__order-info-item-value">
                            <span>{{ orderDetailCommonInfo.shippingAddress }}</span>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- Invoice -->
            <div v-if="showInvoice" class="csr-order-details__invoice">
                <div class="csr-order-details__invoice-title">{{ orderDetailsConfig?.invoiceTitle }}</div>
                <a v-if="orderDetailsConfig?.invoiceButton && orderDetailsConfig?.invoiceLink"
                    :href="orderDetailsConfig?.invoiceLink" :target="orderDetailsConfig?.invoiceTarget"
                    class="csr-order-details__invoice-btn">{{ orderDetailsConfig?.invoiceButton }}</a>
            </div>
            <div :class="['csr-order-details__product-info']">
                <div class="csr-order-details__order-title csr-order-details__product-title">
                    {{ orderDetailsConfig.productInfoTitle }}
                </div>
                <ul class="csr-order-details__product-info-content">
                    <li class="csr-order-details__product-info-item" v-for="(item,index) in orderDetailAry"
                        :key="index">
                        <img class="csr-order-details__product-image lazyload" :src="item.productImage" :alt="item.title" />
                        <div class="csr-order-details__product-info-item-desc-btn">
                            <div :class="[item.archive && 'unavailable', 'csr-order-details__product-info-item-desc']">
                                <div class="csr-order-details__product-parameters">
                                    <span class="csr-order-details__product-parameters-title"
                                        @click="handleJump(item)">{{ item.title }}</span>
                                    <div class="csr-order-details__product-parameters-other">
                                        <span class="csr-order-details__product-model-numb">{{ item.sku }}</span>
                                        <div class="csr-order-details__product-parameters-item-box">
                                            <div :class="[
                                                'csr-order-details__product-parameters-list-item',
                                                ((['colorObj'].includes(attrKey) && !item.customAttributes.colorObj.value) ||
                                                (!['colorObj'].includes(attrKey) && !item.customAttributes[attrKey])) && 'empty'
                                                ]"
                                                v-for="(attrVal, attrKey) in item.customAttributes" :key="attrKey">
                                                <div v-if="['colorObj'].includes(attrKey)"
                                                    class="csr-order-details__product-color">
                                                    <template v-if="attrVal.value">
                                                        <span>{{ item.customAttributes?.colorObj.label }}</span>
                                                    </template>
                                                </div>
                                                <span v-else class="csr-order-details__product-parameters-item">{{
                                                    attrVal }}</span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div class="csr-order-details__product-info-item-price">
                                    <span v-if="isPhonePortrait()" class="csr-order-details__product-info-item-price-num">x{{ item.quantity }}</span>
                                    <Price :variant="{'price': { amount: item.discountedTotalPrice, currencyCode: item?.currencyCode } }" />
                                </div>
                            </div>
                            <div :class="[
                                item.archive && 'unavailable', 
                                (isPhonePortrait() && (!showRecord(item) || recordRenderingFailed) && !showBazaarvoice(item)) && 'no-margin',
                                'csr-order-details__product-info-item-btns'
                                ]">
                                <span v-if="!isPhonePortrait()" class="csr-order-details__product-parameters-num">x{{ item.quantity }}</span>
                                <div class="csr-order-details__btns">
                                    <Record v-if="showRecord(item)"
                                        :dataset="{ 'buttonLabel': orderListConfig.reorderButton, className: 'csr-order-details__btn'}"
                                        :recordVariants="{ sku: item.sku, customAttributes: item.originCustomAttributes }"
                                        @btnRenderingFailed="handleRecordRenderingFailed" />
                                    <div v-if="showBazaarvoice(item)" class="bv-rating csr-order-details__btn"
                                        data-bv-show="rating_summary" :data-bv-product-id="item.sku"></div>
                                    <!-- <button class="csr-order-details__btn">Review</button> -->
                                    <!-- <button class="csr-order-details__btn">Review</button> -->
                                </div>
                            </div>
                            <!--商品下架提示 -->
                            <div v-if="item.archive" class="csr-order-details__product-info-item-unavailable">
                                <i></i>
                                <div>  {{ archiveLabel }}</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="csr-order-details__order-summary">
                <div class="csr-order-details__order-summary-title">
                    {{ orderDetailsConfig.summaryTitle }}
                </div>
                <div class="csr-order-details__order-summary-quantity">
                    <span class="label"> {{ orderDetailsConfig.quanityLabel }}</span>
                    <span class="value">{{ totalQuantity }}</span>
                </div>
                <ul class="csr-order-details__order-summary-list">
                    <!-- <li>
                        <span class="label">{{orderDetailsConfig.subtotalLabel}}</span>
                        <span class="value">无</span>
                    </li> -->
                    <li v-if="!isB2b">
                        <span class="label">{{ orderDetailsConfig.shippingLabel }}</span>
                        <span class="value">
                            <Price
                                :variant="{'price': { amount: orderDetailCommonInfo?.totalShippingPrice || 0.00, currencyCode: orderDetailCommonInfo.currencyCode } }" />
                        </span>
                    </li>
                    <li>
                        <span class="label">{{ orderDetailsConfig.taxLabel }}</span>
                        <span class="value">
                            <Price :variant="{'price': { amount: orderDetailCommonInfo.currentTotalTax, currencyCode:  orderDetailCommonInfo.currencyCode } }" />
                        </span>
                    </li>
                    <li>
                        <span class="label">{{ orderDetailsConfig.totalLabel }}</span>
                        <span class="value total">
                            <Price :variant="{'price': { amount: orderDetailCommonInfo.totalPrice, currencyCode:  orderDetailCommonInfo.currencyCode } }" />
                        </span>
                    </li>
                </ul>
            </div>
            <!-- <div class="csr-order-details__mb-btns gws-mb-sticky-to-bottom"
                v-if="orderDetailCommonInfo.successfulFulfillmentsUrl && orderDetailCommonInfo.orderStatus == _CSP_ORDER_STATUS._FULFILLED">
                <div class="csr-order-details__mb-btns__wrppper">
                    <a :href="orderDetailCommonInfo.successfulFulfillmentsUrl"
                    class="csr-order-details__mb-btn">{{
                    orderListConfig.trackButton }}</a>
                </div>
            </div> -->
        </div>
    </div>
</template>